const RSS_URL =
  '/0VJOBIhJuMPZ0b0HV9Aelp6AfX7E6cLF0EHDMCfAUBc9RD2td7YpuUQrs7X7CSiJ';

export interface YoutubeVideo {
  id: string;
  title: string;
  url: string;
  thumbnail: string;
}

export async function fetchLatestVideo(): Promise<YoutubeVideo | null> {
  try {
    const res = await fetch(RSS_URL);
    if (!res.ok) return null;

    const xml = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(xml, 'application/xml');

    const entry = doc.querySelector('entry');
    if (!entry) return null;

    const videoId = entry.querySelector('videoId')?.textContent ?? '';
    const title = entry.querySelector('title')?.textContent ?? '';
    const url = entry.querySelector('link')?.getAttribute('href') ?? '';
    const thumbnail = videoId
      ? `https://i3.ytimg.com/vi/${videoId}/hqdefault.jpg`
      : '';

    if (!videoId) return null;

    return { id: videoId, title, url, thumbnail };
  } catch {
    return null;
  }
}
